var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("connection-settings-popup", {
    attrs: {
      resources: {
        deletePromptTitle: _vm.resource(
          "JourneyBuilder_FilterSettings_Delete_Title"
        ),
        deletePromptBody: _vm.resource(
          "JourneyBuilder_FilterSettings_Delete_Body"
        ),
        deleteButtonText: _vm.resource(
          "JourneyComposer_JourneyBrickMenu_DeleteConnection"
        )
      }
    },
    on: {
      save: function($event) {
        return _vm.save()
      },
      delete: function($event) {
        return _vm.deleteConnection()
      },
      hidden: function($event) {
        return _vm.$emit("hidden")
      }
    },
    scopedSlots: _vm._u([
      {
        key: "title",
        fn: function() {
          return [
            _c(
              "div",
              [
                _c("h3", [
                  _vm._v(
                    _vm._s(
                      _vm.resource("JourneyComposer_ConnectionModal_Connection")
                    )
                  )
                ]),
                _vm._v(" "),
                _c("copy-id-button", { attrs: { id: _vm.connection.id } })
              ],
              1
            )
          ]
        },
        proxy: true
      },
      {
        key: "body",
        fn: function() {
          return [
            _vm.canBeConfigured
              ? [
                  _c("h4", [
                    _vm._v(
                      _vm._s(
                        _vm.resource(
                          "JourneyBuilder_JourneyBrickMenu_Status_DisplayName"
                        )
                      )
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "row mb-2" },
                    [
                      _c(
                        "label",
                        { staticClass: "col-2", attrs: { for: "active" } },
                        [_vm._v(_vm._s(_vm.resource("Bool_Active")))]
                      ),
                      _vm._v(" "),
                      _c("span", { staticClass: "col-10" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.active,
                              expression: "active"
                            }
                          ],
                          attrs: {
                            id: "active",
                            type: "checkbox",
                            disabled: !_vm.canWrite
                          },
                          domProps: {
                            checked: Array.isArray(_vm.active)
                              ? _vm._i(_vm.active, null) > -1
                              : _vm.active
                          },
                          on: {
                            change: function($event) {
                              var $$a = _vm.active,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = null,
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 && (_vm.active = $$a.concat([$$v]))
                                } else {
                                  $$i > -1 &&
                                    (_vm.active = $$a
                                      .slice(0, $$i)
                                      .concat($$a.slice($$i + 1)))
                                }
                              } else {
                                _vm.active = $$c
                              }
                            }
                          }
                        })
                      ]),
                      _vm._v(" "),
                      _vm.inactiveMessage
                        ? _c("error-message", {
                            staticClass: "col-10 offset-2",
                            attrs: { message: _vm.inactiveMessage }
                          })
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "row mb-2" }, [
                    _c(
                      "label",
                      { staticClass: "col-2", attrs: { for: "activeFrom" } },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.resource(
                              "JourneyComposer_ConnectionModal_ActiveFrom"
                            )
                          )
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c("span", { staticClass: "col-10" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.activeFrom,
                            expression: "activeFrom"
                          }
                        ],
                        staticClass: "form-control",
                        attrs: { type: "date", disabled: !_vm.canWrite },
                        domProps: { value: _vm.activeFrom },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.activeFrom = $event.target.value
                          }
                        }
                      })
                    ])
                  ]),
                  _vm._v(" "),
                  _vm.canWrite ? [_c("hr")] : _vm._e()
                ]
              : _vm._e(),
            _vm._v(" "),
            _vm.canWrite
              ? [
                  _c("h4", [
                    _vm._v(
                      _vm._s(
                        _vm.resource(
                          "JourneyBuilder_JourneyBrick_CommentHeader"
                        )
                      )
                    )
                  ]),
                  _vm._v(" "),
                  _c("new-comment", {
                    attrs: {
                      brickId: _vm.connectionCommentId,
                      id: "newcomment"
                    }
                  })
                ]
              : _vm._e(),
            _vm._v(" "),
            !_vm.connection.isNew
              ? [
                  _c("hr"),
                  _vm._v(" "),
                  _c("h4", [
                    _vm._v(
                      _vm._s(
                        _vm.resource(
                          "JourneyBuilder_JourneyBrickMenu_Comments_DisplayName"
                        )
                      )
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "comment-container" },
                    [
                      _c("comments-section", {
                        attrs: {
                          "related-id": _vm.connection.id,
                          type: "Connection"
                        }
                      })
                    ],
                    1
                  )
                ]
              : _vm._e(),
            _vm._v(" "),
            _vm.displayDeactivationConfirmation
              ? _c("deactivation-confirmation-popup", {
                  attrs: {
                    "object-id": _vm.connection.id,
                    "object-type": "connection"
                  },
                  on: {
                    cancel: function($event) {
                      return _vm.cancelDeactivation()
                    },
                    save: function($event) {
                      return _vm.confirmDeactivation($event)
                    }
                  }
                })
              : _vm._e()
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }